import { callApi } from "./api";
import moment from "moment";

const handleOrdering = (sorting, checkedColumns) => {
  let ordering = [];
  for (const key in sorting) {
    const val = sorting[key];
    if (val) {
      if (val === "ascend") {
        ordering.push("-" + key);
      } else {
        ordering.push(key);
      }
    }
    if (!checkedColumns[key]) {
      ordering = [];
    }
  }
  return ordering;
};

const getQueryString = (queryParams, withoutQuestionMark = false) => {
  if (!queryParams) {
    return "";
  }

  const query = Object.keys(queryParams)
    .filter(key => {
      const value = queryParams[key];
      return value !== undefined && value !== null && value !== "";
    })
    .map(key => {
      const value = queryParams[key];
      return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
    })
    .join("&");

  return query ? (withoutQuestionMark ? query : `?${query}`) : "";
};

export const getOffsetLimitFromPagination = ({ currentPage, pageSize }) => ({
  limit: pageSize,
  offset: (currentPage - 1) * pageSize,
});

class CampaignsService {
  async getCountries() {
    return await callApi({
      url: "/api/countries/",
    });
  }
  async getOperatingSystems() {
    return await callApi({
      url: "/api/os/",
    });
  }
  async getBrowsers() {
    return await callApi({
      url: "/api/browsers/",
    });
  }
  async getProgramsAutocomplete(searchProgramTerm) {
    return await callApi({
      url: `/api/offerwall/programs/autocomplete/?search=${searchProgramTerm}`,
    });
  }

  async requestApproval(id) {
    return await callApi({
      method: "GET",
      url: `/api/offerwall/request_approval/${id}/`,
    });
  }

  async getPricesForCampaign(id) {
    return await callApi({
      url: `/api/offerwall/prices/${id}/`,
    });
  }

  async getLinksForCampaign(id) {
    return await callApi({
      url: `/api/offerwall/links/${id}/`,
    });
  }

  async getCampaignsPaged({
    selectedFilters,
    isArchiveIncluded,
    currentPage,
    checkedColumns,
    pageSize,
    searchValue,
    cancelToken,
    sorting
  }) {
    const { channel, filters } = selectedFilters.filters;
    let colParameter = "status,id";
    Object.keys(checkedColumns).forEach(function (key) {
      if (checkedColumns[key]) {
        colParameter += "," + key;
      }
    });
    const ordering = handleOrdering(sorting, checkedColumns);
    const query = getQueryString({
      ...getOffsetLimitFromPagination({ currentPage, pageSize }),
      channel: Array.isArray(channel) ? channel.join(",") : channel,
      columns: colParameter,
      date_created:
        filters && filters.dateCreated && moment(filters.dateCreated).format("YYYY-MM-DD"),
      // cmp_ids: filters.campaigns && filters.campaigns.join(","),
      status: filters && filters.status && filters.status,
      type: filters && filters.type && filters.type,
      show_archived: isArchiveIncluded ? 1 : 0,
      program: filters && filters.program && filters.program.join(","),
      ordering: ordering && ordering.join(",")
    });
    const response = await callApi({
      url: `/api/offerwall/campaigns/${query}`,
      cancelToken,
    });
    return { results: response.results, count: response.count };
    // return await { results: data, count: 5 };
  }
}

export const coinisCampaignsService = new CampaignsService();
